import React, { useEffect } from 'react';
import BetSlip from './BetSlip';
import connect from 'react-redux/es/connect/connect';
import { priority, priorityModal } from 'configs/layout';
import betSlipSelector from 'common/selectors/betSlipSelector';
import productSelector from 'common/selectors/productSelector';
import {
    getMultitrackCodes,
    getTrackFromRacingCard,
} from 'common/selectors/trackSelector';
import { getCouponFactory } from 'features/BettingREST/couponSelector';
import BetSlipContainer from 'features/BetSlipState/BetSlipContainer';
import {
    resetBet,
    resetSmartLyn,
    setSmartLynMode,
} from 'features/BetSlipState/actions';
import withSmartLynManager from 'features/SmartLyn/withSmartLynManager';
import { isMultitrackProduct } from 'common/selectors/multipleTrackSetupsSelector';

const MobileModal = ({
    product,
    track,
    smartLynMode,
    setSmartLynMode,
    activateSmartLyn,
    enableCloseButton,
    showModal,
    hideModal,
    resetBet,
    resetSmartLyn,
}) => {
    useEffect(() => {
        enableCloseButton();
        return () => {
            resetSmartLyn();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Redirect to receipt modal
     * @return {boolean}
     */
    const skipToReceipt = (betResponse, betPick) => {
        hideModal('BET_SLIP');
        smartLynMode
            ? showModal('SMART_LYN_RECEIPT', priority.overlapBetslipNotifier, {
                  ...betPick,
                  product,
                  track,
                  receipt: betResponse.data,
                  legs: betResponse.data.coupon.legs,
                  resetSmartLyn,
                  nowrap: true,
              })
            : showModal('RECEIPT', priority.overlapBetslipNotifier, {
                  combinationPrice: betResponse.coupon.combinationPrice / 100,
                  ...betPick,
                  totalCost: betResponse.receipt.totalCost,
                  nowrap: true,
              });
        resetBet();
    };

    const toggleSmartLynMode = () => {
        if (smartLynMode) {
            setSmartLynMode(false);
        } else {
            activateSmartLyn();
        }
    };

    return (
        <BetSlipContainer
            onAuthenticationRequired={() =>
                showModal('LOGIN', priorityModal.loginMobile)
            }
            onMobileBetWorkflow={(prices, uSaleInfo, lockedLegs) =>
                showModal('SAVED_BET_CONTAINER', 102, {
                    prices,
                    uSaleInfo,
                    lockedLegs,
                })
            }
            onBetPerformed={skipToReceipt}
        >
            {(betSlipContainer) => (
                <BetSlip
                    {...betSlipContainer}
                    toggleSmartLynMode={toggleSmartLynMode}
                />
            )}
        </BetSlipContainer>
    );
};

const mapStateToProps = (state) => ({
    selectedProduct: productSelector(state), // needed for withSmartLynManager HOC
    trackCode: getTrackFromRacingCard(state).code, // needed for withSmartLynManager HOC
    betSlip: betSlipSelector(state),
    product: productSelector(state),
    track: getTrackFromRacingCard(state),
    date: state.AISDataProvider.racingCardData.date,
    auth: state.auth,
    availableCardsPending: state.BetSlip.availableCardsPending,
    availableCardsError: state.BetSlip.availableCardsError,
    availableCardsData: state.BetSlip.availableCardsData,
    couponFactory: getCouponFactory(state),
    smartLynMode: state.BetSlip.smartLynMode,
    isMultitrack: isMultitrackProduct(state),
    multitrackCodes: getMultitrackCodes(state),
});

const mapDispatchToProps = (dispatch) => ({
    resetBet: () => dispatch(resetBet()),
    setSmartLynMode: (status) => {
        dispatch(setSmartLynMode(status));
    },
    resetSmartLyn: () => {
        dispatch(resetSmartLyn());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withSmartLynManager(MobileModal));
